import { expandDesignerAction } from '../designerReducer';

export const expandDesigner = () => dispatch => {
  dispatch(expandDesignerAction());
};
